<template>
<div class="entries-info mb-3">
  <p v-html="$t('helpers.page_entries_info.more_pages.display_entries', {
    entry_name: $t('backend.e2e.voting_round_reports.show.write_in_votes'),
    first: votesPerPage.start,
    last: votesPerPage.end,
    total: totalItems
    })"
  ></p>
</div>

<nav class="d-none d-md-block m-0">
  <ul class="pagination justify-content-center">
    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <button class="page-link" @click="emits('navigate', 1)">
        {{ $t("views.pagination.first") }}
      </button>
    </li>

    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <button class="page-link" @click="emits('navigate', currentPage - 1)">
        {{ $t("views.pagination.previous") }}
      </button>
    </li>

    <li v-for="page in neighborPages"
      :key="`option_${optionReference}_page_${page}`" class="page-item"
      :class="{ active: page === currentPage }">
      <button class="page-link" @click="emits('navigate', page)">
        {{ page }}
      </button>
    </li>

    <li class="page-item"
      :class="{ disabled: currentPage * itemsPerPage > totalItems }">
      <button class="page-link" @click="emits('navigate', currentPage + 1)">
        {{ $t("views.pagination.next") }}
      </button>
    </li>

    <li class="page-item"
      :class="{ disabled: currentPage * itemsPerPage > totalItems }">
      <button class="page-link"
        @click="emits('navigate', Math.ceil(totalItems / itemsPerPage))">
        {{ $t("views.pagination.last") }}
      </button>
    </li>
  </ul>
</nav>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  const props = defineProps({
    optionReference: {
      type: String,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  });

  const emits = defineEmits(["navigate"]);

  const neighborPages = computed<Array<Number>>(() => {
    const start = Math.max(1, props.currentPage - 2);
    const end = Math.min(Math.ceil(props.totalItems / props.itemsPerPage), props.currentPage + 2);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  });

  const votesPerPage = computed(() => {
    const start = props.currentPage === 1 ? 1 : ((props.currentPage - 1) * props.itemsPerPage) + 1;
    const end = start + props.itemsPerPage - 1;
    return { start, end: end > props.totalItems ? props.totalItems : end };
  });
</script>
